// 지점 내 승급/CP 획득 공지 배너 — 전체 공지를 한 줄 마퀴로 표시, × 버튼으로 전체 닫기
import type { NotificationItem } from "../hooks/useTierPromotion";

const TIER_EMOJI: Record<string, string> = {
  IRON: "⚙️",
  BRONZE: "🥉",
  SILVER: "🥈",
  GOLD: "🥇",
  PLATINUM: "💎",
  DIAMOND: "💠",
  MASTER: "👑",
  CHALLENGER: "🏆",
};

function toSegment(item: NotificationItem): string {
  if (item.kind === "tier") {
    const emoji = TIER_EMOJI[item.new_tier] ?? "🎉";
    const label = item.is_placement ? "배치" : "승급";
    return `${emoji} ${item.student_name} 학생이 ${item.tier_kr} ${item.level_label}로 ${label}했습니다!`;
  }
  return `💰 ${item.student_name} 학생이 ${item.cp_amount.toLocaleString()}CP를 획득했습니다!`;
}

interface Props {
  queue: NotificationItem[];
  onDismissAll: () => void;
}

export default function TierPromotionBanner({ queue, onDismissAll }: Props) {
  const marqueeText = queue.map(toSegment).join("     ");

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex justify-center pointer-events-none">
      <div
        className="mt-3 mx-4 max-w-sm w-full pointer-events-auto
          bg-white/95 backdrop-blur-sm border border-amber-200
          rounded-xl shadow-lg shadow-amber-100/60
          px-4 py-2.5 flex items-center gap-3
          animate-slide-down"
      >
        <div className="flex-1 overflow-hidden">
          <p className="animate-marquee whitespace-nowrap inline-block text-sm font-medium text-gray-800 leading-snug">
            {marqueeText}
          </p>
        </div>
        <button
          onClick={onDismissAll}
          className="text-gray-400 hover:text-gray-600 flex-shrink-0 text-lg leading-none"
          aria-label="닫기"
        >
          ×
        </button>
      </div>
    </div>
  );
}
